import { Formik } from 'formik'

import { ModalWrapper } from 'src/components'
import { InviteForm } from './invite-form.component'
import { useSendAccountUserInvite } from 'src/hooks'
import { EAccountRoles, IAccountUserInviteFormDto } from 'src/types'

import { inviteAccountUserSchema } from 'src/common/validations'
import { useStyles } from '../styles'

interface IInviteModalProps {
  open: boolean
  handleVerifyOpen: () => void
  handleClose: () => void
}

const initialValues = {
  email: '',
  role: EAccountRoles.scanner,
}

const InviteModal = ({ handleClose, open, handleVerifyOpen }: IInviteModalProps) => {
  const classes = useStyles()
  const { mutateAsync } = useSendAccountUserInvite()

  const handleSubmit = async (values: IAccountUserInviteFormDto) => {
    const resp = await mutateAsync({ email: values.email, roles: [values.role] })
    if (!resp) return
    handleClose()
    if (resp.verify_transfer_ownership_token) {
      handleVerifyOpen()
    }
  }

  return (
    <ModalWrapper open={open} onClose={handleClose} className={classes.inviteModalWrapper}>
      <>
        <Formik
          initialValues={initialValues}
          validationSchema={inviteAccountUserSchema}
          onSubmit={handleSubmit}
        >
          <InviteForm />
        </Formik>
      </>
    </ModalWrapper>
  )
}

export { InviteModal }
